import { RentalGrowthListingWebApiHandler_getByAddress } from '@zg-rentals/ts-rental-growth-api-client';
import type {
  GetListingByAddressListingFilterInputDto,
  GetListingByAddressRequestDto,
  GetListingByAddressResponseDto,
} from '@zg-rentals/ts-rental-growth-api-client';

export type { GetListingByAddressRequestDto, GetListingByAddressResponseDto };

export type FilterParamsType = {
  activeTypes?: string | null;
  amenities?: string | null;
  bedrooms?: string | null;
  activatedDays?: number | null;
  deactivatedDays?: number | null;
  distanceInMiles?: number | null;
  laundry?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: string;
  pets?: string | null;
  price?: number | null;
  propertyTypes?: string | null;
};

export const buildSimilarFloorplansFilter = (params: FilterParamsType): GetListingByAddressListingFilterInputDto => {
  const {
    activeTypes,
    activatedDays,
    amenities,
    bedrooms,
    deactivatedDays,
    distanceInMiles,
    laundry,
    limit,
    offset,
    orderBy,
    pets,
    price,
    propertyTypes,
  } = params;

  return {
    orderBy: orderBy || 'lowPrice',
    ...(activeTypes && { activeTypes }),
    ...(activatedDays != null && { activatedDays }),
    ...(amenities && { amenities }),
    ...(bedrooms && { bedrooms }),
    ...(deactivatedDays != null && { deactivatedDays }),
    ...(distanceInMiles != null && { distanceInMiles }),
    ...(laundry && { laundry }),
    ...(limit != null && { limit }),
    ...(offset != null && { offset }),
    ...(pets && { pets }),
    ...(price != null && { price }),
    ...(propertyTypes && { propertyTypes }),
  };
};

export const getListingByAddress = (
  params: GetListingByAddressRequestDto,
  client?: Parameters<typeof RentalGrowthListingWebApiHandler_getByAddress>[1],
): Promise<GetListingByAddressResponseDto> => RentalGrowthListingWebApiHandler_getByAddress(params, client);
